export default {
  root: ({ context, props }) => ({
    class: [
      // Position and Shadows
      'absolute',
      'shadow-sm',
      'p-fadein',
      // Spacing
      {
        'py-0 px-1':
          context?.right ||
          context?.left ||
          (!context?.right && !context?.left && !context?.top && !context?.bottom),
        'py-1 px-0': context?.top || context?.bottom
      }
    ]
  }),
  arrow: ({ context, props }) => ({
    class: [
      // Position

      'absolute',

      // Size
      'w-0',
      'h-0',

      // Shape
      'border-transparent',
      'border-solid',
      {
        'border-y-[0.5rem] border-r-[0.5rem] border-l-0 border-r-surface-1000':
          context?.right ||
          (!context?.right && !context?.left && !context?.top && !context?.bottom),
        'border-y-[0.5rem] border-l-[0.5rem] border-r-0 border-l-surface-1000': context?.left,
        'border-x-[0.5rem] border-t-[0.5rem] border-b-0 border-t-surface-1000': context?.top,
        'border-x-[0.5rem] border-b-[0.5rem] border-t-0 border-b-surface-1000': context?.bottom
      },

      // Spacing
      {
        '-mt-2 ':
          context?.right ||
          (!context?.right && !context?.left && !context?.top && !context?.bottom),
        '-mt-2': context?.left,
        '-ml-2': context?.top || context?.bottom
      }
    ]
  }),
  text: ({ context, props }) => ({
    class: [
      'p-3',
      'bg-surface-1000 dark:bg-surface-700',
      'text-white',
      'leading-4',
      'rounded-sm',
      'break-words',
      'text-text-sm',
      'max-w-80',
      // Spacing
      {
        'ml-1 ':
          context?.right ||
          (!context?.right && !context?.left && !context?.top && !context?.bottom),
        'mr-1': context?.left,
        'mt-1': context?.bottom,
        'mb-1': context?.top
      }
    ]
  })
}
